<p class="control-title"><strong>Visit reason</strong></p>
<ui-dropdown-simple
    [keyName]="'name'"
    [valueName]="'id'"
    [optionsList]="reasons"
    [selectedValue]="selectedValue"
    [disabled]="disabled()"
    (valueChange)="onSelectionChange($event)"
    [placeholder]="'Select'">
</ui-dropdown-simple>
